<template>
  <router-view/>
</template>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.recharge_score_btn{
  background: linear-gradient(90deg, rgba(255, 141, 26, 1),rgba(250, 100, 0, 1));
  border: none !important;
  color: #ffffff !important;
  //禁止换行
  white-space: nowrap;
}
</style>
